module.exports = __webpack_public_path__ + "img/JORNAY_Vector_Charts-2-mobile-noicon.e36c1073.png";